import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useGymProfile } from "../hooks/useGymProfile";

/**
 * Gates the booking flows on a completed profile (spec Section 8): if
 * profileCompletedAt is null, send the user to the setup form first. Sits inside
 * ProtectedRoute, so the user is already known to be authenticated here.
 */
export function RequireProfile({ children }: { children: ReactNode }) {
  const { isLoading, error, isComplete } = useGymProfile();

  if (isLoading) {
    return <div className="state-panel">Loading your profile…</div>;
  }

  if (error) {
    return (
      <div className="state-panel">
        <h2>Couldn&rsquo;t load your profile</h2>
        <p>{error}</p>
      </div>
    );
  }

  if (!isComplete) {
    return <Navigate to="/gym/profile" replace />;
  }

  return <>{children}</>;
}
